import shared from './shared'
import { LigaUtils } from '../utils/ligaUtils'

export default {
    shared,
    async createUserLiga (createUserLigaRequest) {
        try {
            LigaUtils.validateCreateUserLigaRequest(createUserLigaRequest)
            const createUserLiga = this.shared.functions().httpsCallable('createUserLiga')
            let data = await createUserLiga(createUserLigaRequest)
            return data.data
        } catch (error) {
            console.log(error)
            return false
        }
    },
    async deleteUserLiga (deleteUserLigaRequest) {
        try {
            LigaUtils.validateDeleteUserLigaRequest(deleteUserLigaRequest)
            const deleteUserLiga = this.shared.functions().httpsCallable('deleteUserLiga')
            let data = await deleteUserLiga(deleteUserLigaRequest)
            return data.data
        } catch (error) {
            console.log(error)
            return false
        }
    },

    async joinUserLiga (joinUserLigaRequest) {
        try {
            LigaUtils.validateJoinUserLigaRequest(joinUserLigaRequest)
            const joinUserLiga = this.shared.functions().httpsCallable('joinUserLiga')
            let data = await joinUserLiga(joinUserLigaRequest)
            return data.data
        } catch (error) {
            console.log(error)
            return false
        }
    },

    async removeUserFromLiga (removeUserFromLigaRequest) {
        try {
            LigaUtils.validateRemoveUserFromLigaRequest(removeUserFromLigaRequest)
            const removeUserFromLiga = this.shared.functions().httpsCallable('removeUserFromLiga')
            let data = await removeUserFromLiga(removeUserFromLigaRequest)
            return data.data
        } catch (error) {
            console.error(error)
            return false
        }
    },

    async getAllLeaugeUsers (ligaId) {
        try {
            let request = { ligaId }
            LigaUtils.validateJoinUserLigaRequest(request)
            const joinUserLiga = this.shared.functions().httpsCallable('joinUserLiga')
            let data = await joinUserLiga(request)
            return data.data
        } catch (error) {
            console.log(error)
            return false
        }
    },

    async getLigaName (ligaId) {
        try {
            if (!ligaId) {
                return false
            }
            let ligaNameRef = await this.shared.db().ref(`/userLige/${ligaId}/nazivLige`).once('value')
            return ligaNameRef.val()
        } catch (error) {
            console.log(error)
            return false
        }
    },
    async getLigaNatjecatelji (ligaId) {
        try {
            if (!ligaId) {
                return false
            }
            let ligaNatjecateljiRef = await this.shared.db().ref(`/userLige/${ligaId}/clanoviLige`).once('value')
            let ligaNatjecateljiData = ligaNatjecateljiRef.exportVal()
            if (!ligaNatjecateljiData) {
                ligaNatjecateljiData = {}
            }
            return ligaNatjecateljiData
        } catch (error) {
            console.log(error)
            return false
        }
    },

    async getLigaNameAndNatjecateljiCount (ligaId) {
        try {
            if (!ligaId) {
                return false
            }
            let ligaRef = await this.shared.db().ref(`/userLige/${ligaId}`).once('value')
            let liga = ligaRef.exportVal()
            if (!liga) {
                liga = {}
            }
            let natjecateljiKeys = Object.values(liga.clanoviLige)
            let count = natjecateljiKeys.length
            let nazivLige = liga.nazivLige
            return {
                nazivLige,
                count
            }
        } catch (error) {
            console.log(error)
            return false
        }
    },

    async getAllMyLeaugeIds (uid) {
        try {
            if (!uid) {
                return false
            }
            let ligeRef = await this.shared.db().ref(`/users/${uid}/inLeauges`).once('value')
            let lige = ligeRef.exportVal()
            if (!lige) {
                lige = {}
            }
            lige = Object.values(lige)
            return lige
        } catch (error) {
            console.log(error)
            return false
        }
    }
}
